<span class="sign">$</span>
<wm-input-text [(ngModel)]="facade" [required]="required" [min]="min" [max]="max" (blur)="blur()"></wm-input-text>
